<template>
    <section>
        <individual-item v-for="(owner, i) in owners" :key="i" :individual="owner"/>
    </section>
</template>

<script>
import IndividualItem from "./items/IndividualItem.vue";
export default {
    name: "Individuals",
    components:{
        IndividualItem
    },
    props: {
        individuals: {
            type: Array,
            required: true
        }
    },
    computed:{
        owners(){
            if (this.individuals){
                return this.individuals.filter(o => o.type == 'OWNER')
            }
            return [];
        }
    }
}
</script>

<style>

</style>